module.exports = __webpack_public_path__ + "static/img/liveManage.b2ef7dd8.png";